/**
 * TanStack Query hooks for `per-publisher-fraud-rule-sets`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	perPublisherFraudRuleSetsQueryKeys,
	type CreatePerPublisherFraudRuleSetsBody,
	type ListPerPublisherFraudRuleSetsResponse,
	type PerPublisherFraudRuleSetsRow,
} from "./api";

export function usePerPublisherFraudRuleSetsList(): UseQueryResult<ListPerPublisherFraudRuleSetsResponse, Error> {
	return useQuery({
		queryKey: perPublisherFraudRuleSetsQueryKeys.list(),
		queryFn: list,
	});
}

export function usePerPublisherFraudRuleSetsCreate(): UseMutationResult<PerPublisherFraudRuleSetsRow, Error, CreatePerPublisherFraudRuleSetsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: perPublisherFraudRuleSetsQueryKeys.all });
		},
	});
}

export function usePerPublisherFraudRuleSetsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: perPublisherFraudRuleSetsQueryKeys.all });
		},
	});
}
